import { useQuery } from '@tanstack/react-query'
import { useSearchParams } from 'react-router-dom'
import { queryKeys, QUERY_CONFIG } from '../../lib/react-query'
import { ticketsApi } from '../../services/api'
import { useAuthStore } from '../../store/authStore'
import type { TicketResponse } from '../../app/modules/types/ticket'

/**
 * Hook for fetching paginated tickets list
 * Automatically refetches when URL params change
 */
export function useTickets() {
  const orgId = useAuthStore((state) => state.orgId)
  const [searchParams] = useSearchParams()
  const params = searchParams.toString()

  return useQuery({
    queryKey: queryKeys.tickets.list(orgId, params),
    queryFn: () => ticketsApi.getList(params),
    enabled: !!orgId,
  })
}

/**
 * Hook for fetching a single ticket by ID
 */
export function useTicketDetail(id: string | null) {
  const orgId = useAuthStore((state) => state.orgId)
  return useQuery({
    queryKey: queryKeys.tickets.detail(orgId, id || ''),
    queryFn: () => ticketsApi.getById(id!),
    enabled: !!id && !!orgId,
  })
}

/**
 * Hook for fetching ticket filter options
 */
export function useTicketFilterOptions() {
  const orgId = useAuthStore((state) => state.orgId)
  return useQuery({
    queryKey: queryKeys.tickets.filterOptions(orgId),
    queryFn: () => ticketsApi.getFilterOptions(),
    staleTime: QUERY_CONFIG.LISTS.staleTime,
    enabled: !!orgId,
  })
}
